// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_home__1jket {
  /* display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column; */
  /* min-height: calc(100vh - 60px);
  min-height: calc(100dvh); */
}
.home_inner__iVYU5 {
  background: #000;
  min-height: calc(100vh - 60px);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  width: 100%;
}

@media screen and (min-width: 1200px) {
  .home_inner__iVYU5 {
    min-height: 100vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/home.module.css"],"names":[],"mappings":"AAAA;EACE;;;;2BAIyB;EACzB;6BAC2B;AAC7B;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".home {\n  /* display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex-direction: column; */\n  /* min-height: calc(100vh - 60px);\n  min-height: calc(100dvh); */\n}\n.inner {\n  background: #000;\n  min-height: calc(100vh - 60px);\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n@media screen and (min-width: 1200px) {\n  .inner {\n    min-height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `home_home__1jket`,
	"inner": `home_inner__iVYU5`
};
export default ___CSS_LOADER_EXPORT___;
